.dispatch-header {
  max-width: 1800px;
  margin: .25rem auto 0;
  padding: 0 .8125rem;
  overflow: visible;
}
.dispatch-header, .dispatch-toolbar-counters {
  /* Les fonds, contours et icônes dérivent des mêmes couleurs sémantiques. */
  --dispatch-soft-overlay-success:
    linear-gradient(color-mix(in srgb, var(--color-accent) calc(var(--dispatch-chrome-soft-darken-alpha, 0) * 100%), transparent), color-mix(in srgb, var(--color-accent) calc(var(--dispatch-chrome-soft-darken-alpha, 0) * 100%), transparent)),
    linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)));
  --dispatch-soft-overlay-warning:
    linear-gradient(color-mix(in srgb, var(--color-amber) calc(var(--dispatch-chrome-soft-darken-alpha, 0) * 100%), transparent), color-mix(in srgb, var(--color-amber) calc(var(--dispatch-chrome-soft-darken-alpha, 0) * 100%), transparent)),
    linear-gradient(rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)), rgb(255 255 255 / var(--dispatch-chrome-soft-lighten-alpha, 0)));
  --dispatch-day-icon-border: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.16 + var(--dispatch-colored-border-delta, 0)) * 100%), 100%), transparent);
  --dispatch-day-icon-fill: color-mix(in srgb, var(--color-accent) 16%, white);
  --dispatch-day-icon-surface: var(--dispatch-soft-overlay-success), linear-gradient(var(--dispatch-day-icon-fill), var(--dispatch-day-icon-fill));
}
.dispatch-header-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
  min-width: 0;
}
.dispatch-header-day { padding-bottom: 2px; }
.dispatch-header-summary {
  padding: 4px;
  border: 0;
  background: transparent;
  box-shadow: none;
}
/* Align every header row with the board's outer left border, in every Dispatch tab (the phone layout keeps its padding). */
@media (min-width: 721px) {
  :is([data-results-dispatch-ribbon-root] .dispatch-header, [data-results-detail-toolbar-root="true"]) {
    max-width: none;
    padding-left: 0;
  }
  [data-results-dispatch-ribbon-root] .dispatch-header-summary {
    padding-left: 0;
  }
}
.dispatch-header-day-context, .dispatch-header-primary, .dispatch-header-work {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.dispatch-header-primary { margin-left: auto; justify-content: flex-end; }
.dispatch-header-work { justify-content: flex-end; }
.dispatch-header-counters {
  flex: 1 1 600px;
  min-width: 0;
  /* Stronger counter fills, scoped here and still driven by colour intensity. */
  --dispatch-counter-success-fill: color-mix(in srgb, var(--color-accent) 24%, white);
  --dispatch-counter-warning-fill: color-mix(in srgb, var(--color-amber) 32%, white);
  --dispatch-counter-success-icon-fill: color-mix(in srgb, var(--color-accent) 34%, white);
  --dispatch-counter-warning-icon-fill: color-mix(in srgb, var(--color-amber) 42%, white);
  --dispatch-counter-warning-ink: color-mix(in srgb, var(--color-amber) 48%, black);
  --dispatch-card-success-accent: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.42 + var(--dispatch-colored-border-delta, 0)) * 100%), 100%), transparent);
  --dispatch-card-success-border: color-mix(in srgb, var(--color-accent) clamp(0%, calc((0.22 + var(--dispatch-colored-border-delta, 0)) * 100%), 100%), transparent);
  --dispatch-card-warning-accent: color-mix(in srgb, var(--color-amber) clamp(0%, calc((0.48 + var(--dispatch-colored-border-delta, 0)) * 100%), 100%), transparent);
  --dispatch-card-warning-border: color-mix(in srgb, var(--color-amber) clamp(0%, calc((0.18 + var(--dispatch-colored-border-delta, 0)) * 100%), 100%), transparent);
  --dispatch-card-warning-icon-border: color-mix(in srgb, var(--color-amber) clamp(0%, calc((0.15 + var(--dispatch-colored-border-delta, 0)) * 100%), 100%), transparent);
  --dispatch-card-success-surface: var(--dispatch-soft-overlay-success), linear-gradient(var(--dispatch-counter-success-fill), var(--dispatch-counter-success-fill));
  --dispatch-card-warning-surface: var(--dispatch-soft-overlay-warning), linear-gradient(var(--dispatch-counter-warning-fill), var(--dispatch-counter-warning-fill));
  --dispatch-card-success-icon: var(--dispatch-soft-overlay-success), linear-gradient(var(--dispatch-counter-success-icon-fill), var(--dispatch-counter-success-icon-fill));
  --dispatch-card-warning-icon: var(--dispatch-soft-overlay-warning), linear-gradient(var(--dispatch-counter-warning-icon-fill), var(--dispatch-counter-warning-icon-fill));
}
.dispatch-header-counters [data-dispatch-indicator-card] { height: 100%; min-height: 3rem; padding-top: 3px; padding-bottom: 3px; }
.dispatch-header-counters > section > .grid { column-gap: 16px; }
.dispatch-header-source-changes-slot { display: contents; }
.dispatch-header-source-changes-slot > div,
.dispatch-header-source-changes-slot > div > span { width: 100%; min-width: 0; }
.dispatch-header-source-changes-slot [data-source-changes-trigger] { width: 100%; min-height: 3rem !important; }
.dispatch-header-source-changes-slot [data-source-changes-trigger] > span {
  flex-wrap: wrap;
  justify-content: center;
  white-space: normal;
}
.dispatch-header-source-changes-slot [data-source-changes-trigger] > span > span:first-child { white-space: nowrap; }
.dispatch-header-counters [data-dispatch-indicator-tone="success"] > span:first-child > span,
.dispatch-header-counters [data-dispatch-indicator-tone="success"] strong,
.dispatch-header-counters [data-dispatch-indicator-tone="success"] > span:last-child > span {
  color: var(--color-accent-strong);
}
.dispatch-header-counters [data-dispatch-indicator-tone="warning"] > span:first-child > span,
.dispatch-header-counters [data-dispatch-indicator-tone="warning"] strong,
.dispatch-header-counters [data-dispatch-indicator-tone="warning"] > span:last-child > span {
  color: var(--dispatch-counter-warning-ink);
}
/* Indicateurs compacts sur la rangée des onglets (Vue flotte, Route…). */
.dispatch-toolbar-counters { flex: none; }
.dispatch-toolbar-counters > section > .grid { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 6px; }
.dispatch-toolbar-counters [data-dispatch-indicator-card] {
  display: flex;
  align-items: center;
  gap: 6px;
  width: auto;
  height: 2.0625rem;
  min-height: 0;
  padding: 0 10px 0 4px;
}
.dispatch-toolbar-counters [data-dispatch-indicator-card]::before { display: none; }
.dispatch-toolbar-counters [data-dispatch-indicator-card] > span:first-child { display: flex; align-items: center; gap: 6px; }
.dispatch-toolbar-counters [data-dispatch-indicator-card] > span:first-child > span:first-child {
  font-size: .84rem;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: none;
}
.dispatch-toolbar-counters [data-dispatch-indicator-card] > span:last-child { order: -1; min-height: 0; align-items: center; }
.dispatch-toolbar-counters [data-dispatch-indicator-card] > span:last-child > span { width: 1.5rem; height: 1.5rem; min-height: 0; align-self: center; }
/* Vue flotte affiche déjà la liste « Cmd Suspendues » : l'indicateur Suspendues y est masqué. */
body:has(#fleet-view[aria-hidden="false"]) .dispatch-toolbar-counters > section > .grid > :is([data-detail-view-link="suspended"], :has([data-detail-view-link="suspended"])) { display: none; }
.dispatch-header-portal { margin-left: auto; }
.dispatch-header-slot:empty { display: none; }
.dispatch-context-menu > div + div {
  border-top: 1px solid var(--shell-chrome-line, #e2e5e4);
  margin-top: 4px;
  padding-top: 4px;
}

.dispatch-header-menu-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 2.0625rem;
  padding: 0 10px;
  border: 1px solid var(--shell-chrome-line, #e2e5e4);
  border-radius: 4px;
  background: white;
  color: var(--color-content-copy);
  font-size: .84rem;
  font-weight: 600;
  white-space: nowrap;
}
.dispatch-header-menu-trigger:hover { background: var(--shell-chrome-soft, #f5f6f5); }
/* Menu Affichage dans la barre du Gantt : même hauteur et même texte que ses boutons voisins. */
.dispatch-header-menu-trigger.fleet-display-menu-trigger { min-height: 2.25rem; border-color: #cbd5e1; color: #334155; font-size: .68rem; }
.dispatch-header-menu-trigger.fleet-display-menu-trigger.is-geotab-on { border-color: var(--color-accent); color: var(--color-accent); }
.dispatch-header-menu-trigger:focus-visible { outline: 2px solid var(--color-accent); outline-offset: 2px; }
.dispatch-header-menu-trigger.dispatch-optimization-period-trigger {
  margin-left: -1px;
  width: 28px;
  padding: 0;
  border-radius: 0 4px 4px 0;
  border-color: var(--color-accent);
  border-left-color: rgb(255 255 255 / 35%);
  background: var(--color-accent);
  color: white;
}
.dispatch-header-menu-trigger.dispatch-optimization-period-trigger:hover {
  border-color: var(--color-accent-strong);
  background: var(--color-accent-strong);
}
.dispatch-header-menu-trigger.dispatch-optimization-period-trigger:disabled {
  border-color: #e2e8f0;
  background: #f8fafc;
  color: #94a3b8;
}
.dispatch-header-menu-trigger.dispatch-optimization-period-trigger.has-status-notice { border-radius: 0; }
.dispatch-header-menu {
  z-index: 1500;
  width: 350px;
  max-width: calc(100vw - 16px);
  max-height: calc(100dvh - 16px);
  overflow-y: auto;
  border: 1px solid var(--shell-chrome-line, #e2e5e4);
  border-radius: 4px;
  background: white;
  padding: 4px;
  box-shadow: 0 8px 24px #172c2926;
}
.dispatch-header-menu[hidden] { display: none; }
.dispatch-header-menu-section + .dispatch-header-menu-section { margin-top: 4px; padding-top: 4px; border-top: 1px solid var(--shell-chrome-line, #e2e5e4); }
.dispatch-header-menu-label { padding: 4px 8px; font-size: .64rem; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; color: var(--color-content-copy); }
.dispatch-header-menu-section[data-danger] .dispatch-header-menu-label { color: #b91c1c; }
/* Menu Affichage : titres de section foncés et un peu plus grands, plus faciles à lire. */
.dispatch-display-menu .dispatch-header-menu-label { font-size: .68rem; color: var(--color-content-ink); }
.dispatch-header-menu .dispatch-header-menu-row,
.dispatch-header-menu .dispatch-header-menu-action {
  display: flex !important;
  justify-content: flex-start !important;
  width: 100% !important;
  min-height: 32px !important;
  height: auto !important;
  border-radius: 4px !important;
  border: 1px solid transparent !important;
  padding: 6px 8px !important;
  font-size: .84rem !important;
  line-height: 1.35 !important;
  text-align: left !important;
  box-shadow: none !important;
  background: white !important;
  color: var(--color-content-ink) !important;
}
.dispatch-header-menu .dispatch-header-menu-action:hover,
.dispatch-header-menu .dispatch-header-menu-action:focus-visible { background: var(--shell-chrome-soft, #f5f6f5) !important; }
.dispatch-header-menu [data-danger] .dispatch-header-menu-action { color: #b91c1c !important; }
.dispatch-header-menu .dispatch-header-menu-action:disabled { opacity: .55; }
.dispatch-header-menu .dispatch-header-menu-action[data-destructive] { color: var(--color-danger) !important; }
.dispatch-header-menu [data-dispatch-day-state-actions] { display: block; }
.dispatch-header-menu-action > span { display: flex; align-items: center; gap: 8px; }
.dispatch-header-menu-row, .dispatch-header-menu-action { gap: 8px; }
.dispatch-header-menu-row svg, .dispatch-header-menu-action svg { width: 14px; height: 14px; flex-shrink: 0; }

.dispatch-header-more-menu {
  width: 320px;
  max-width: calc(100% - 16px);
  padding: 10px 12px;
  border-color: rgba(148, 163, 184, .22);
  box-shadow: 0 8px 24px rgba(15, 23, 42, .12);
}
.dispatch-header-more-menu .dispatch-header-menu-row,
.dispatch-header-more-menu .dispatch-header-menu-action {
  align-items: center;
  gap: 10px;
  padding: 5px 10px !important;
  font-weight: 500 !important;
  background: transparent !important;
}
.dispatch-header-more-menu .dispatch-header-menu-action > span { gap: 10px; }
.dispatch-header-more-menu .dispatch-header-menu-action > svg,
.dispatch-header-more-menu .dispatch-header-menu-action > span > svg,
.dispatch-header-more-menu .dispatch-header-menu-row svg { width: 16px; height: 16px; }
.dispatch-header-more-menu .dispatch-header-menu-action > svg,
.dispatch-header-more-menu .dispatch-header-menu-row svg { color: rgba(71, 85, 105, .82); }
.dispatch-header-more-menu .dispatch-header-menu-action:not(:disabled):hover,
.dispatch-header-more-menu .dispatch-header-menu-action:not(:disabled):focus-visible { background: var(--color-surface-accent-tint) !important; }
.dispatch-header-more-menu .dispatch-header-menu-action:focus-visible { outline: 2px solid var(--color-accent); outline-offset: -2px; }
.dispatch-header-more-menu .dispatch-header-menu-action:disabled { opacity: .45; }
.dispatch-header-more-menu [data-dispatch-reassignment-mode-control] { margin-bottom: 4px; }
.dispatch-header-more-menu .dispatch-header-menu-label {
  padding: 0 4px 5px;
  font-size: .68rem;
  font-weight: 600;
  letter-spacing: .06em;
  color: rgba(71, 85, 105, .7);
}
.dispatch-header-more [data-dispatch-color-intensity-control] { display: flex; }
.dispatch-header-more-portal { border-top: 1px solid rgba(148, 163, 184, .15); margin-top: 8px; padding-top: 8px; }
.dispatch-header-more-portal:not(:has([data-driver-portal-publication-actions])) { display: none; }
.dispatch-header-more-portal .dispatch-header-slot > div { display: block; }
.dispatch-header-more [data-driver-portal-publication-actions] { display: grid; justify-content: stretch; width: 100%; gap: 0; }
.dispatch-header-more [data-driver-portal-publication-actions] > span { justify-content: flex-start; }
